import React, { useEffect, useState } from "react";
import TableComponent from "../../../layoutComponents/TableComponent";
import CreatePayment from "./CreatePayment";
import { EndPoints } from "../../../utils/EndPoints";
import { apiCall } from "../../../redux/modules/moduleActions";
import { Box, Typography } from "@mui/material";
const paymentDataHeaders = [
  "Sr.No.",
  "Date",
  "Payment ID",
  "Payment Amount",
  "Allocated to Bills",
  "Allocated to Advance",
  "Remark",
  //   "Actions",
];
const getFormattedDate = (dateString) => {
  const date = new Date(dateString);
  const options = { month: "short", day: "numeric", year: "numeric" };
  const formattedDate = date.toLocaleDateString("en-US", options);
  const day = date.getDate();

  const daySuffix =
    day === 1 || day === 21 || day === 31
      ? "st"
      : day === 2 || day === 22
      ? "nd"
      : day === 3 || day === 23
      ? "rd"
      : "th";

  return formattedDate.replace(day, `${day}${daySuffix}`);
};


function TransporterPayments({ singlelistView, TransportersFunction }) {
  const [payments, setPayments] = useState({ list: [], advance: 0, count: 0 });
  const fetchPayments = async (transporterDetail, nextURL="") => {
    const getNextBill = EndPoints.transporterPayments.getList();
    const res = await apiCall({
      method: "get",
      api: nextURL ? nextURL : `${getNextBill}?transporter_id=${transporterDetail.id}`,
    });
    setPayments({ list: res.results, ...res });
  };
  
  useEffect(() => {
    if (singlelistView && singlelistView !== null) {
      fetchPayments(singlelistView);
    }
  }, [singlelistView]);
  return (
    <Box>
      
      <TableComponent
        header={paymentDataHeaders}
        descending={true}
        tableList={
          payments.list && payments.list.length > 0
            ? payments.list.map((item, index) => {
                const date = item.payment_date;
                return {
                  ...item,
                  Date: getFormattedDate(date),
                  "Payment ID": item.payment_id,
                  "Payment Amount": `₹ ${Number(
                    item.payment_amount ?? 0
                  ).toFixed(0)}/-`,
                  "Allocated to Bills": `₹ ${item.paid_bills
                    .reduce((sum, bill) => {
                      return sum + parseFloat(bill.allocated_to_bill || 0);
                    }, 0)
                    .toFixed(0)}/-`,
                  "Allocated to Advance": `₹ ${Number(
                    item.allocated_to_advanced ?? 0
                  ).toFixed(0)}/-`,
                  Remark: item.remark,
                };
              })
            : []
        }
        module="Payment"
        customCreateFile={(rest) => {
          return (
            <CreatePayment
              {...rest}
              transporterDetail={singlelistView}
              apiCall={TransportersFunction}
              onClose={() => {
                rest.onClose();
                if (singlelistView && singlelistView !== null) {
                  fetchPayments(singlelistView);
                }
              }}
            />
          );
        }}
        pagination={{
          count: payments.count,
          next: payments.next,
          previous: payments.previous,
          customPagination: true,
          tablePagination: (url) => {
            fetchPayments(singlelistView, url);
          },
        }}
      />
    </Box>
  );
}

export default TransporterPayments;
